module.exports = __webpack_public_path__ + "static/media/lock.64566de6.ico";